<div class="page-container no-scroll" [class.loading]="isLoading">
    <app-header [title]="'time-tracking.timesheetsIndexPage.title'" [menuService]="menuService"> </app-header>

    <mat-form-field class="static-width">
        <mat-date-range-input [rangePicker]="picker" [formGroup]="range">
            <input matStartDate formControlName="start" name="startDate" placeholder="Start date" readonly />
            <input matEndDate formControlName="end" name="endDate" placeholder="End date" readonly />
        </mat-date-range-input>
        <mat-date-range-picker (closed)="onDateSelectionComplete()" #picker></mat-date-range-picker>
        <mat-datepicker-toggle matSuffix [for]="picker">
            <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
        </mat-datepicker-toggle>
    </mat-form-field>
    <ui-card class="scrollable-table-container" [withMargin]="false" [withSpacing]="false">
        <app-table [isResponsive]="true" [noPadding]="true" [embedded]="true" [showOffset]="true" [table]="table">
            <app-empty-state
                label="{{ 'time-tracking.reportsIndexPage.table.emptyState' | translate }}"
                src="/assets/illustrations/empty-box.png"
            ></app-empty-state>
            <div class="buttons">
                <ui-button type="outline" [matMenu]="exportMenu">
                    {{ 'time-tracking.reportsIndexPage.table.export' | translate }}
                    <mat-icon svgIcon="chevronDown"></mat-icon>
                </ui-button>
                <mat-menu #exportMenu="matMenu">
                    <button mat-menu-item (click)="onExport('csv', 'csv')">
                        {{ 'time-tracking.reportsIndexPage.table.csv' | translate }}
                    </button>
                    <button mat-menu-item (click)="onExport('xlsx', 'excel')">
                        {{ 'time-tracking.reportsIndexPage.table.excel' | translate }}
                    </button>
                </mat-menu>
            </div>
        </app-table>
    </ui-card>
</div>
